export default [ URL="//user-images.githubusercontent.com/70900247/192085197-06c5b6fa-d65b-497f-84c8-b923f6f5b0eb.jpg",
URL="//user-images.githubusercontent.com/70900247/192085661-f8d81d19-3057-401b-af5a-099a6b2e4c46.jpg",
URL="//user-images.githubusercontent.com/70900247/192085662-017fffb6-3063-4f80-90c2-28e7765a3d51.jpg",
URL="//user-images.githubusercontent.com/70900247/192085721-05a9d20a-fc88-40f4-918e-d5a1c796dde9.jpg",
URL="//user-images.githubusercontent.com/70900247/192085665-5e8a1997-c1d4-4037-a7ac-ed8e0251944e.jpg",
URL="//user-images.githubusercontent.com/70900247/192085667-9edf2e7f-af3f-482a-9b61-eaa2e2aeef33.jpg",
URL="//user-images.githubusercontent.com/70900247/192085671-930eebb2-31ce-43ab-a9e4-78de7a19edaf.jpg",
URL="//user-images.githubusercontent.com/70900247/192085672-6101ef03-bbc9-450d-91d2-52edd8b8f738.jpg",
URL="//user-images.githubusercontent.com/70900247/192085675-9d8cb45b-ab39-4d05-bca6-840e96618dc9.jpg",
] 


